export const featureHelpers = {
  store: null,
  featureEnabled: (feature) => featureEnabled(featureHelpers.store, feature),
  featuresEnabled: (requiredFeatures) => featuresEnabled(featureHelpers.store, requiredFeatures),
  getFeatureList: () => getFeatureList(featureHelpers.store),
}

function getFeatureList(store) {
  const { tenant } = store.getState();
  const featureList = !!tenant && !!tenant.currentTenant ? tenant.currentTenant.featureList : undefined;
  return featureList;
}

function featureEnabled(store, feature) {
  const featureList = getFeatureList(store);
  var setting = featureList && featureList.find(val => val.name === feature);
  return !!setting ? setting.enabled : false;
}

function featuresEnabled(store, requiredFeatures) {
  const featureList = getFeatureList(store);
  var featuresEnabled = true;
  !!requiredFeatures && requiredFeatures.forEach(feature => {
    var setting = featureList && featureList.find(val => val.name === feature);
    if(!setting || setting.enabled === false) {
      featuresEnabled = false;
      return;
    }
  });
  return featuresEnabled;
}
